import { differenceInSeconds } from "date-fns"

export const DifferenceInDate = (startDate?: Date | null, endDate?: Date | null) => {
  let differenceCalc: string | null = null
  let differences = endDate && startDate ? differenceInSeconds(new Date(endDate), new Date(startDate)) : null

  if (differences) {
    const daysCalc = differences / 86400
    let hourCal = ((daysCalc % 1) * 86400) / 3600
    let minCalc = ((hourCal % 1) * 3600) / 60
    let days = Math.floor(daysCalc)
    let hour = Math.floor(hourCal)
    let min = Math.floor(minCalc)
    let sec = Math.floor((minCalc % 1) * 60)

    differenceCalc = `${days > 0 ? `${days}d ` : ''}${hour > 0 ? `${hour}h ` : ''}${min > 0 ? `${min}m ` : ''}${sec > 0 ? `${sec}s` : ''}`
  }

  return differenceCalc
}

export function toUnitTimeZone(
  date: Date,
  offset: number = -6,
) {
  // Create a new Date object from the original date
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  // Apply offset (in minutes) and return new date
  const adjustedDate = new Date(utcDate.getTime() + offset * 60 * 60000);

  return adjustedDate;
}

export function calculateDateWithOffset(date: string | Date, offsetMinutes: number): Date {
  // Convert the input into a Date object
  const originalDate = typeof date === "string" ? new Date(date) : date;

  if (isNaN(originalDate.getTime())) {
      throw new Error("Invalid date");
  }

  // Calculate the new date by adding the offset in milliseconds
  const newDate = new Date(originalDate.getTime() + offsetMinutes * 60 * 1000);

  return newDate;
}